var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBarChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.833333 0C0.373096 0 0 0.373096 0 0.833334V16.6667C0 17.5871 0.746192 18.3333 1.66667 18.3333H17.5C17.9602 18.3333 18.3333 17.9602 18.3333 17.5C18.3333 17.0398 17.9602 16.6667 17.5 16.6667L2.5 16.6667C2.03976 16.6667 1.66667 16.2936 1.66667 15.8333V0.833333C1.66667 0.373096 1.29357 0 0.833333 0Z",
    fill: "#A35C05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 10.8333C4.16667 10.3731 4.53976 10 5 10C5.46024 10 5.83333 10.3731 5.83333 10.8333V13.3333C5.83333 13.7936 5.46024 14.1667 5 14.1667C4.53976 14.1667 4.16667 13.7936 4.16667 13.3333V10.8333Z",
    fill: "#A35C05"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 7.5C7.8731 7.5 7.5 7.8731 7.5 8.33333V13.3333C7.5 13.7936 7.8731 14.1667 8.33333 14.1667C8.79357 14.1667 9.16667 13.7936 9.16667 13.3333V8.33333C9.16667 7.8731 8.79357 7.5 8.33333 7.5Z",
    fill: "#A35C05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 5.83333C10.8333 5.3731 11.2064 5 11.6667 5C12.1269 5 12.5 5.3731 12.5 5.83333V13.3333C12.5 13.7936 12.1269 14.1667 11.6667 14.1667C11.2064 14.1667 10.8333 13.7936 10.8333 13.3333V5.83333Z",
    fill: "#A35C05"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.5C14.5398 2.5 14.1667 2.8731 14.1667 3.33333V13.3333C14.1667 13.7936 14.5398 14.1667 15 14.1667C15.4602 14.1667 15.8333 13.7936 15.8333 13.3333V3.33333C15.8333 2.8731 15.4602 2.5 15 2.5Z",
    fill: "#A35C05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChart);
export default __webpack_public_path__ + "static/media/bar-chart.414f2d63.svg";
export { ForwardRef as ReactComponent };